import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {LiquidityAccount} from "../entity/liquidity_account";
import {URLSearchParams} from '@angular/http';

@Injectable()
export class BanksService {
    constructor(private http: Http) {
    }

    private banks: Array<any>;

    getBanks(): Observable<Array<any>> {
        if (isEmpty(this.banks)) {
            return this.http.get('/api/backoffice/banks')
                .map(response => response.json())
                .map(response => {
                    this.banks = response["banks"];
                    return this.banks;
                });
        } else {
            return Observable.of(this.banks);
        }
    }

    getBanksByCurrency(currency_id: number): Observable<Array<any>> {
        return this.http.get(`/api/backoffice/banks?currency-id=${currency_id}`)
            .map(response => response.json()["banks"])
    }

    getBanksByCurrencyAndCouldCreateCurrentAccount(currencyId: number, couldCreateCurrentAccount: boolean): Observable<Array<any>> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('currencyId', currencyId.toString());
        params.set('couldCreateCurrentAccount', couldCreateCurrentAccount.toString());
        return this.http.get('/api/backoffice/banks',
            {search: params})
            .map(response => response.json()["banks"])
    }

    getLiquidityByBankAndCurrency(data: { bank: number, currency: number }): Observable<LiquidityAccount[]> {
        return this.http.get(`/api/backoffice/customers/liquidity-accounts?bank-id=${data.bank}&currency-id=${data.currency}`)
            .map(response => response.json()['accounts']);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/banks.service.ts